import * as io from 'io-ts';
import { isRight } from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';

export const APIError = io.type({
  code: io.number,
  domain: io.string,
  message: io.string,
  metadata: io.record(io.string, io.string),
  reason: io.string,
});

export const PaymentsAPIError = io.type({
  code: io.number,
  error: io.string,
  message: io.string,
  details: io.array(
    io.type({
      reason: io.string,
      domain: io.string,
      metadata: io.record(io.string, io.string),
    })
  ),
});

export type APIError = io.TypeOf<typeof APIError>;
export type PaymentsAPIError = io.TypeOf<typeof APIError>;

export function isAPIError(err: unknown): err is APIError {
  return pipe(APIError.decode(err), isRight);
}
